import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const MembersOnly = ({ children, officers = false }) => {
  const { user } = useAuth();
  if (user === null || user === undefined) return null;
  const member = user && (user.validated || user.is_super_admin || ["elder", "admin"].includes(user.role));
  const officer = user && (user.is_super_admin || ["elder", "admin"].includes(user.role));
  if (officers ? officer : member) return children;
  return (
    <div className="max-w-xl mx-auto px-6 py-16 text-center" data-testid="members-only">
      <Lock className="w-10 h-10 mx-auto text-[#993D22] mb-4" />
      <h1 className="font-serif-heritage text-3xl text-[#261911] mb-3">
        {!user ? "Espace réservé aux membres" : officers ? "Espace réservé aux responsables" : "Compte en attente de validation"}
      </h1>
      <p className="text-[#6E5B4F] mb-6">
        {!user
          ? "Les généalogies, les fiches et les photos de famille sont protégées. Connectez-vous ou demandez un accès pour les consulter."
          : officers ? "Cette page est réservée aux anciens et aux administrateurs."
          : "Un administrateur doit valider votre compte avant que vous puissiez consulter les généalogies."}
      </p>
      {!user && (
        <div className="flex justify-center gap-3">
          <Link to="/login" className="btn-terra text-sm" data-testid="members-only-login">Se connecter</Link>
          <Link to="/register" className="btn-outline-terra text-sm">Demander un accès</Link>
        </div>
      )}
      <Link to="/histoire" className="block mt-6 text-sm text-[#993D22] underline">Découvrir l'histoire d'Ekom 1 et des Evondo</Link>
    </div>
  );
};

export default MembersOnly;
